import React, { useContext } from 'react';
import { Modal } from 'reactstrap';
import ModalContext from '../../context/ModalContext';

const DefaultModal = () => {
  const {
    isOpen,
    toggle,
    className,
    content,
  } = useContext(ModalContext);

  const Component = content && content.component ? content.component : null;
  const componentProps = content && content.props ? content.props : {};
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} className={className} backdrop={true}>
        {Component && <Component {...componentProps} />}
      </Modal>
    </div>
  );
};

export default DefaultModal;
